var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',{attrs:{"element":"main-view"}},[_c('el-aside',{staticStyle:{"width":"auto"},attrs:{"element":"main-aside"}},[_vm._t("menu",null,{"controller":_vm._controller})],2),_c('el-main',{attrs:{"element":"main-body"}},[_vm._t("body",null,{"controller":_vm._controller})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }